import { render, staticRenderFns } from "./Workflow2.vue?vue&type=template&id=5f931fc0&scoped=true&"
import script from "./Workflow2.vue?vue&type=script&lang=js&"
export * from "./Workflow2.vue?vue&type=script&lang=js&"
import style0 from "./Workflow2.vue?vue&type=style&index=0&id=5f931fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f931fc0",
  null
  
)

component.options.__file = "Workflow2.vue"
export default component.exports